// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AbsoluteIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AbsoluteIcon" ref={forwardedRef} {...props}>
      <path d="M.588 10.31c0 3.052 1.218 4.69 3.472 4.69s3.472-1.638 3.472-4.69V9.428c0-3.052-1.218-4.676-3.472-4.676S.588 6.376.588 9.428zm1.694 1.54c-.098-.42-.14-.91-.14-1.484V9.372c0-2.128.658-3.248 1.918-3.248.644 0 1.134.308 1.456.924zm1.778 1.778c-.658 0-1.148-.308-1.47-.896l3.234-4.816a7.3 7.3 0 0 1 .14 1.456l.014.994c.028 2.142-.63 3.262-1.918 3.262" />
      <path d="M15.777 15c-2.254 0-3.472-1.638-3.472-4.69V9.428c0-3.052 1.218-4.676 3.472-4.676s3.472 1.624 3.472 4.676v.882c0 3.052-1.218 4.69-3.472 4.69m-1.918-4.634c0 .574.042 1.064.14 1.484l3.234-4.802c-.322-.616-.812-.924-1.456-.924-1.26 0-1.918 1.12-1.918 3.248zm.448 2.366c.322.588.812.896 1.47.896 1.288 0 1.946-1.12 1.918-3.262L17.68 9.372a7.3 7.3 0 0 0-.14-1.456z" />
      <path d="M9.927 14.902c-.602 0-1.008-.42-1.008-.994 0-.588.406-1.008 1.008-1.008.574 0 .994.42.994 1.008a.964.964 0 0 1-.994.994" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AbsoluteIcon = /* @__PURE__ */ Object.assign(
  AbsoluteIconComponent,
  { displayName: 'AbsoluteIcon' },
);
